/* PDP gallery upgrade — desktop prev/next arrows for gallery_layout: "thumbnail".
   Pairs with assets/component-gallery-v8.css.

   Why not use Dawn's native slider-component prev/next for the main image?
   At >=750px, assets/section-main-product.css sets every non-active
   .product__media-item to display:none (".product--thumbnail
   .product__media-item:not(.is-active)"). slider-component's own
   initPages() (assets/global.js) filters slides by clientWidth > 0, so with
   only one slide visible it bails out before computing a scroll offset —
   its prev/next buttons never advance anything on desktop in this layout.

   Instead, clicking our arrow just .click()s the previous/next thumbnail
   button. That reuses media-gallery.js's existing setActiveMedia flow
   untouched (is-active state, live region announcement, thumbnail sync,
   pausing video/models) instead of duplicating it. Variant-driven media
   swaps are unaffected — this file never listens for variant change
   events, only for clicks on the two arrow buttons it creates. */
(function () {
  function buildArrowButton(direction) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gallery-arrow-v8 gallery-arrow-v8--' + direction;
    button.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
    var path = direction === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
    button.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + path + '"></path></svg>';
    return button;
  }

  function getThumbnailButtons(thumbnails) {
    return Array.from(thumbnails.querySelectorAll('.thumbnail-list__item[data-target] button'));
  }

  function goToRelativeThumbnail(thumbnails, direction) {
    var buttons = getThumbnailButtons(thumbnails);
    if (buttons.length < 2) return;
    var currentIndex = buttons.findIndex(function (button) {
      return button.getAttribute('aria-current') === 'true';
    });
    if (currentIndex === -1) currentIndex = 0;
    var nextIndex = (currentIndex + direction + buttons.length) % buttons.length;
    buttons[nextIndex].click();
  }

  function initGallery(mediaGallery) {
    if (mediaGallery.dataset.galleryArrowsV8 === 'true') return;
    if (mediaGallery.dataset.desktopLayout !== 'thumbnail') return;

    var viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
    var thumbnails = mediaGallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!viewer || !thumbnails) return; // single-image products don't render a thumbnail rail

    mediaGallery.dataset.galleryArrowsV8 = 'true';

    var nav = document.createElement('div');
    nav.className = 'gallery-arrows-v8';

    var prevButton = buildArrowButton('prev');
    var nextButton = buildArrowButton('next');
    nav.appendChild(prevButton);
    nav.appendChild(nextButton);
    viewer.appendChild(nav);

    prevButton.addEventListener('click', function () {
      goToRelativeThumbnail(thumbnails, -1);
    });
    nextButton.addEventListener('click', function () {
      goToRelativeThumbnail(thumbnails, 1);
    });
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after theme-editor / quick-add / ajax section reloads.
  document.addEventListener('shopify:section:load', initAll);
})();
